import { useState } from 'react';
import { Link } from 'react-router';
import { Clock, X } from 'lucide-react';
import { useAuthStore } from '@/features/auth/stores/auth-store';
import { useTrayNotices } from '../NoticeTray';
import styles from './TrialBanner.module.css';

function getTrialDaysRemaining(trialExpiresAt: string | undefined): number | null {
  if (!trialExpiresAt) return null;

  const expires = new Date(trialExpiresAt);
  if (isNaN(expires.getTime())) return null;

  const now = new Date();
  const diffMs = expires.getTime() - now.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return Math.max(0, diffDays);
}

export function TrialBanner() {
  const user = useAuthStore((s) => s.user);
  const [dismissed, setDismissed] = useState(false);

  const daysRemaining = user?.subscriptionStatus === 'trial' ? getTrialDaysRemaining(user.trialExpiresAt) : null;
  const dayLabel = daysRemaining === 1 ? 'dia' : 'dias';
  const shown = !dismissed && daysRemaining !== null;
  // No resumo do topo, só um lembrete: aparece quando não há outro aviso.
  useTrayNotices(
    shown
      ? [
          {
            key: 'trial',
            text: daysRemaining > 0 ? `Teste gratuito: expira em ${daysRemaining} ${dayLabel}` : 'Teste gratuito: expira hoje',
            level: 'info',
          },
        ]
      : [],
  );

  if (!shown) return null;

  return (
    <div className={styles.banner}>
      {/*
        Icone, texto e link ficam num bloco so. Soltos como irmaos do botao de
        fechar, o `flex-wrap` do celular mandava o × sozinho para uma terceira
        linha, centralizado e sem relacao visual com o texto que ele fecha.
      */}
      <div className={styles.message}>
        <Clock size={16} className={styles.icon} />
        <span className={styles.text}>
          {daysRemaining > 0 ? (
            <>
              Seu teste gratuito expira em{' '}
              <span className={styles.days}>
                {daysRemaining} {dayLabel}
              </span>
              .
            </>
          ) : (
            <>Seu teste gratuito expira hoje.</>
          )}
        </span>
        <Link to="/billing" className={styles.link}>
          Assinar agora
        </Link>
      </div>
      <button
        className={styles.dismissBtn}
        onClick={() => setDismissed(true)}
        aria-label="Fechar aviso de teste gratuito"
      >
        <X size={14} strokeWidth={1.5} />
      </button>
    </div>
  );
}
